import React, {Fragment, PureComponent} from 'react';
import {Field, reduxForm} from 'redux-form'

import Input from '../../Form/Field/Input.jsx';
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx';
import Loader from '../../../../shared/components/Loader/Loader.jsx';

import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js';
import validate from './validate.js';

import './ContactDetailForm.scss';

export const name = 'ContactDetailForm';

class ContactDetailForm extends PureComponent {
  render() {
    return <Fragment>
      <form id={name} className="contact-detail-form" onSubmit={this.props.onSubmit}>
        <FormGlobalErrors errors={this.props.error}/>
        <Field label="Prénom*" name="user.firstname" placeholder="John..." type="text" component={Input}/>
        <Field label="Nom*" name="user.lastname" placeholder="Doe..." type="text" component={Input}/>
        <Field label="Numéro de téléphone*" name="user.tel" placeholder="+33612345678" component={Input} type="tel"/>
        <p className="text-center">Cela vous permettra notamment de recevoir nos missions par SMS</p>
      </form>
      <Loader visible={this.props.submitting || this.props.triggerSubmit}/>
    </Fragment>;
  }
}

export default reduxForm({
  form: name,
  onSubmitFail: createOnSubmitFailHandler(name, false),
  validate
})(ContactDetailForm);
